import { ClientsRepository } from '@Clients/Data/Repository/ClientsRepository'
import { Clients } from '../Model/Clients'

export interface SearchClient {
    execute(query: string): Promise<Clients[]>
    getSource(): string
}

export class SearchClientUseCase implements SearchClient {
    constructor(private repository: ClientsRepository) {}
    async execute(query: string): Promise<Clients[]> {
        return this.repository.search(query)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
